module.exports = __webpack_public_path__ + "static/img/avatar_r_14.124732a1.png";